import React from "react";

const About = () => {
  return (
    <div>
      <h1>Goal</h1>
      <p>
        The goal is to build a developer friendly opensource website that will
        have every resource in the single place to clear the frontend interview.
      </p>
      <h1>The Plan</h1>
      <p>
        Write now, we are starting with providing the solutions and
        visualisations to various Popular Machine Coding Problems, but later in
        time we will have a proper-defined path for freshers, junior-developer
        interview and senior-developer-interview
      </p>
    </div>
  );
};

export default About;
